import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getContinuousEducationSectionSchedulesAction } from '../actions';

const {
  useLoader: useContinuousEducationSectionSchedulesLoader,
  useLoaderData: useContinuousEducationSectionSchedulesLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationSectionSchedulesAction,
});

function ContinuousEducationSectionSchedulesLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  ContinuousEducationSectionSchedulesLoader,
  useContinuousEducationSectionSchedulesLoader,
  useContinuousEducationSectionSchedulesLoaderData,
};
